export default __webpack_public_path__ + "static/media/MIDAS.2f98be44.jpg";